import { LIST_OF_ACCESS_ICONS_IN_SETTINGS, USER_ROLE } from '../../static/constants.js';
import { NAVIGATION_PATHS } from '../../static/navigationPaths.js';

export const determineSelected = (navItems, settingsItems, currentPath, setSelected, setSettingsPanelIsOpen) => {
  const pathParts = currentPath.split('/');
  let remainingPath = pathParts.slice(3).join('/');
  
  let allItems = [...navItems, ...settingsItems].map((item) => {
    if (item.subItems) {
      return item.subItems.map((subItem) => {
        return {
          ...subItem,
          parentName: item.name,
        };
      });
    } else {
      return item;
    }
  });

  if (remainingPath === NAVIGATION_PATHS.HOME) {
    remainingPath = '/';
  }
  if (remainingPath === NAVIGATION_PATHS.USER_PROFILE) {
    remainingPath = 'userProfile';
  }

  const currentItem = allItems.flat().find((item) => item.to === remainingPath);
  if (currentItem) {
    setSelected(currentItem.title);

    if (currentItem.menu === 'settings') {
      setSettingsPanelIsOpen(true);
    }
  } else {
    setSelected(null);
  }
};

export const HELP_BUTTON_MENU_ITEMS = [
  {
    label: 'Help',
    value: 'help',
    icon: 'help',
    leadingIconType: 'component',
    leadingIconComponentProps: { external: true, externalType: 'all' },
  },
  {
    label: 'Tyler Community',
    value: 'tylerCommunity',
    icon: 'group',
    leadingIconType: 'component',
    leadingIconComponentProps: { external: true, externalType: 'all' },
  },
  {
    label: 'Tyler University',
    value: 'tylerUniversity',
    icon: 'school',
    leadingIconType: 'component',
    leadingIconComponentProps: { external: true, externalType: 'all' },
  },
  {
    label: 'MyView',
    value: 'myView',
    icon: 'video',
    leadingIconType: 'component',
    leadingIconComponentProps: { external: true, externalType: 'all' },
  },
  {
    label: 'Tyler Support',
    value: 'tylerSupport',
    icon: 'headset',
    leadingIconType: 'component',
    leadingIconComponentProps: { external: true, externalType: 'all' },
  },
  {
    label: 'About PBB',
    value: 'aboutPBB',
    icon: 'info_outline',
    leadingIconType: 'component',
    leadingIconComponentProps: { external: true, externalType: 'all' },
  }
];

export const getUserRole = (user) => {
  if (!user) return 'Not logged in';
  else if (user.role === USER_ROLE.ADMIN) return 'RXAdmin';
  else if (user.role === USER_ROLE.SUPER_USER) return 'Super User';
  else return 'Department User';
};

export const shouldSettingsButtonBeVisible = (organizationAccessIcons, user) => {
  if (user?.role === USER_ROLE.ADMIN || user?.role === USER_ROLE.SUPER_USER) {
    return true;
  } else {
    const hasAccessToSome = LIST_OF_ACCESS_ICONS_IN_SETTINGS.some(icon =>
      organizationAccessIcons.find(accessIcon => accessIcon.name === icon)?.departmentUser
    );
    return hasAccessToSome;
  }
};

export const getRelevantBudgets = (allBudgets, user) => {
  if (user?.role === USER_ROLE.SUPER_USER) {
    return allBudgets.filter(budget => budget.isEnabledSU);
  } else if (user?.role === USER_ROLE.DEPARTMENT_USER) {
    return allBudgets.filter(budget => budget.isEnabledDU);
  } else {
    return allBudgets;
  }
};
